import { jsx, jsxs } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useWindowSize } from '@websolutespa/bom-mixer-hooks';
import { IconLlmArrowLeft, IconLlmArrowRight } from '@websolutespa/bom-mixer-icons';
import { useRef } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { clamp } from '../../utils.js';
import { Product } from '../Product/product.js';

const ProductGroupSlider = props => {
  const {
    item
  } = props;
  useWindowSize();
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const swiperProps = {
    modules: [Navigation],
    spaceBetween: clamp(16, 24),
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    watchOverflow: true,
    centeredSlides: false,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current
    },
    breakpoints: {
      630: {
        // slidesPerView: 1.5,
        slidesPerGroup: 1
      },
      768: {
        // slidesPerView: 1.5,
        slidesPerGroup: 1
      },
      1024: {
        // slidesPerView: 2,
        slidesPerGroup: 2
      },
      1280: {
        // slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  };
  const classNames = getClassNames('llm__products');
  return jsx("div", {
    className: classNames,
    children: jsxs(Swiper, Object.assign({}, swiperProps, {
      children: [jsxs("div", {
        className: "llm__products-nav",
        children: [jsx("button", {
          ref: navigationPrevRef,
          children: jsx(IconLlmArrowLeft, {})
        }), jsx("button", {
          ref: navigationNextRef,
          children: jsx(IconLlmArrowRight, {})
        })]
      }), item.items.map((item, i) => jsx(SwiperSlide, {
        className: "llm__products-slide",
        children: jsx(Product, Object.assign({}, props, {
          item: item
        }))
      }, i))]
    }))
  });
};

export { ProductGroupSlider };
//# sourceMappingURL=product-group-slider.js.map
